import {useTranslation} from "react-i18next";
import Button from "../../../../components/Button.jsx";
import {useErrorTranslation} from "../../../../api/utilities/translateErrorMessage.js";
import useIntegrationScript from "../IntegrationFormInput/useIntegrationScript.js";
import useHostNameXmlLinksIntegrationState from "../IntegrationFormInput/useHostNameXmlLinksIntegrationState.js";
import TextareaWithClipboard from "../../../../components/TextareaWithClipboard.jsx";
import HostNameAndXmlLinkList from "../IntegrationFormInput/HostNameAndXmlLinkList.jsx";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import {ProjectIntegrationsApi} from "../../../../api/authority/generated/index";
import toast from "react-hot-toast";
import {useContext} from "react";
import {GlobalContext} from "../../../../utils/context/GlobalContextProvider.jsx";
import {useNavigate} from "react-router-dom";
import {IntegrationActions, IntegrationSection} from "../IntegrationDetailUi.jsx";

export default function ShoptetIntegrationForm({project, projectIntegration}) {
    let {t} = useTranslation();
    let {et} = useErrorTranslation();
    let {resetCurrentUserProjects} = useContext(GlobalContext);
    let navigate = useNavigate();

    let authorityConfiguration = useAuthorityConfiguration();

    let integrationScript = useIntegrationScript('shoptet', projectIntegration?.id);

    let [integrationSettings, setIntegrationSettings] = useHostNameXmlLinksIntegrationState(projectIntegration);

    let createShoptetIntegration = () => {
        new ProjectIntegrationsApi(authorityConfiguration)
            .shoptetIntegration({
                projectId: project.id,
                integrationId: projectIntegration?.id ?? null,
                shoptetIntegrationInput: integrationSettings,
            })
            .then(shoptetIntegrationData => {
                navigate(
                    '/project/' + project.id + '/settings/integrations?integrationId=' + shoptetIntegrationData.id
                );
                resetCurrentUserProjects();
                toast.success(projectIntegration === null ? t('created') : t('saved'));
            })
            .catch(e => et(e).then((message) => { if (message) toast.error(message); }));
    };

    // noinspection JSUnresolvedReference
    return (
        <div className={'flex flex-col gap-5'}>
            {projectIntegration !== null && <>
                <IntegrationSection
                    title={t('integration.shoptet.script-title')}
                    description={t('integration.eprivacy-warning')}
                >
                        <TextareaWithClipboard
                            value={integrationScript}
                            showButton={true}
                        />
                </IntegrationSection>
            </>}

            <IntegrationSection
                title={'Domény a XML feedy'}
                description={'Každá doména může používat vlastní XML zdroj objednávek.'}
            >
            <HostNameAndXmlLinkList
                project={project}
                projectIntegration={projectIntegration}
                value={integrationSettings.hostNameAndXmlLinkList}
                onChange={(hostNameAndXmlLinkList) => {
                    setIntegrationSettings((integrationSettings) => {
                        return {...integrationSettings, hostNameAndXmlLinkList: hostNameAndXmlLinkList};
                    });
                }}
            />
            <div className={'mt-5'}>
            <IntegrationActions>
                <Button
                    className={'button-primary'}
                    onClick={() => createShoptetIntegration()}
                    title={projectIntegration ? 'Uložit změny' : 'Vytvořit integraci'}
                >
                    {projectIntegration ? 'Uložit změny' : 'Vytvořit integraci'}
                </Button>
            </IntegrationActions>
            </div>
            </IntegrationSection>
        </div>
    );
}
